<template>
    <v-card>
        <loading-component :value="loading"/>
        <v-card-title primary-title class="font-weight-bold primary">
            User Settings
        </v-card-title>
        <v-card class="px-4">
            <v-checkbox v-if="hasPermission('CAN_UPDATE_USER_META_show_ticket_popups')"
                        v-model="meta.show_ticket_popups"
                        label="Show New Tickets Popups"
                        color="primary"
            />
            <v-checkbox v-if="hasPermission('CAN_UPDATE_USER_META_receive_telegram_messages')"
                        v-model="meta.receive_telegram_messages"
                        label="Receive Telegram Messages"
                        color="primary"
            />
            <v-btn color="primary" @click="save">
                save
            </v-btn>
        </v-card>
    </v-card>
</template>

<script>
    import LoadingComponent from "@/components/LoadingComponent";

    export default {
        name: "UserSettings",
        components: {LoadingComponent},
        data() {
            return {
                meta: {
                    show_ticket_popups: false,
                    receive_telegram_messages: false
                },
                loading: false
            }
        },
        mounted() {
            this.meta = this.$store.state.user.meta;
        },
        methods: {
            save() {
                this.loading = true;
                this.axios.put(this.api.ACTIONS.USER_META(this.$store.state.user.id), this.meta)
                    .then(x => window.getApp.$emit("SHOW_TOAST", "Saved", "green"))
                    .catch(({response: {data}}) => window.getApp.$emit("SHOW_TOAST", data.message, 'red'))
                    .finally(() => this.loading = false);

            }
        }
    }
</script>

<style scoped>

</style>
